import './index.scss';

class Popup {
    constructor(root) {
        this.root = root;

        document.querySelectorAll('a[href="#' + this.root.id + '"]').forEach((link) => {
            link.addEventListener('click', (event) => {
                event.preventDefault();
                this.open();
            });
        });

        this.root.querySelector('.popup-overlay')?.addEventListener('click', (event) => {
            event.preventDefault();
            this.close();
        });

        this.root.querySelector('button.popup-close')?.addEventListener('click', (event) => {
            event.preventDefault();
            this.close();
        });
    }

    open() {
        this.root.classList.add('opened');

        if (!document.querySelector('.overlay.shown')) {
            window.app.disableScrolling();
        }
    }

    close() {
        this.root.classList.remove('opened');

        if (!document.querySelector('.overlay.shown')) {
            window.app.enableScrolling();
        }
    }
}

window.app.run(() => {
    let popups = [];

    document.querySelectorAll('.frame-type-b13-popup-container').forEach((node) => {
        popups.push(new Popup(node));
    });

    window.openPopup = (id) => {
        popups.forEach((popup) => {
            if (popup.root.id == id) {
                popup.open();
            }
        });
    };
});
